import React from 'react'
import { arrayOf, string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Markdown from 'components/atoms/MarkdownContent'
import CaseSvg from 'components/atoms/SVGIcons/Case'
import BulletSvg from 'components/atoms/SVGIcons/Bullet'

import SectionTitleWithIcon from 'components/molecules/SectionTitleWithIcon'

const CareerResponsibilities = ({ title, responsibilities }) => (
  <div id="responsibilities" className="career-responsibilities">
    <SectionContainer
      paddingBottom={80}
    >
      <Container>
        <Row>
          <Col md="8">
            <SectionTitleWithIcon
              icon={props => <CaseSvg fill="#0FC3C4" height="32px" width="32px" {...props}/>}
              title={title}
            />

            <div className="career-responsibilities__list">
              {
                responsibilities.map((r, idx) => (
                  <div className="career-responsibilities__list-item" key={`cr-li-${idx}`}>
                    <BulletSvg fill="#0FC3C4" height="24px" width="18px"/>
                    <Markdown content={r} />
                  </div>
                ))
              }
            </div>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .career-responsibilities {
          &__list {
            margin: 32px 0;
          }
          &__list-item {
            display: flex;
            align-items: flex-start;
            :global(svg) {
              min-width: 18px;
              margin-right: 16px;
            }
          }
        }
      `}
    </style>
  </div>
)

CareerResponsibilities.propTypes = {
  title: string,
  responsibilities: arrayOf(string),
}

export default CareerResponsibilities
